import type { Content, NormalizedContent } from "@tmi/types/entities";
import type { CompositionContext } from "@/services/data/sync-supervisor";

export function hydrateContent( item: NormalizedContent, ctx: CompositionContext ): Content {
    const author = item.authorId ? ctx.getAuthorById( item.authorId ) : undefined;
    const adProduct = item.adProductId ? ctx.getProductById( item.adProductId ) : undefined;

    const categories = item.categoryIds
        .map( id => ctx.getCategoryById( id ) )
        .filter( c => c !== undefined );

    const industrySectors = item.industrySectorIds
        .map( id => ctx.getIndustrySectorById( id ) )
        .filter( s => s !== undefined );

    const products = item.productIds
        .map( id => ctx.getProductById( id ) )
        .filter( p => p !== undefined );

    const sectors = item.sectorIds
        .map( id => ctx.getSectorById( id ) )
        .filter( s => s !== undefined );

    const tags = item.tagIds
        .map( id => ctx.getTagById( id ) )
        .filter( t => t !== undefined );

    const tickers = item.tickerIds
        .map( id => ctx.getTickerById( id ) )
        .filter( t => t !== undefined );

    return {
        contentfulId: item.contentfulId,
        slug: item.slug,
        updatedDate: item.updatedDate,
        publishedDate: item.publishedDate,
        title: item.title,
        text: item.text,
        body2: item.body2,
        preview: item.preview,
        thumbnail: item.thumbnail,
        videoLink: item.videoLink,
        editorialAd: item.editorialAd,
        isFeatured: item.isFeatured,
        pdfLink: item.pdfLink,
        registrationUri: item.registrationUri,
        webinarDate: item.webinarDate,
        author,
        adProduct,
        categories,
        industrySectors,
        products,
        sectors,
        tags,
        tickers
    };
}
